var pic1 = require('../../assets/images/facility/tour/pic1.jpg');
var pic2 = require('../../assets/images/facility/tour/pic2.jpg');
var pic3 = require('../../assets/images/facility/tour/pic3.jpg');
var pic4 = require('../../assets/images/facility/tour/pic4.jpg');
var pic5 = require('../../assets/images/facility/tour/pic2.jpg');
const DataGalleryFacilityTour = [
 {    
	id: 1,
	title:"tour",
    image: pic1,	    
	alt  :"tour",
  },
  {    
	id: 2,
	title:"tour",
    image: pic2,	    
	alt: "tour",
  },
  {    
	id: 3,
	title:"tour",
    image: pic3,	    
	alt: "tour",
  },
  {    
	id: 4,
	title:"tour",
    image: pic4,	    
	alt: "tour",
  },
  {    
	id: 5,
	title:"tour",
    image: pic5,	    
	alt: "tour",
  },
];
export default DataGalleryFacilityTour;